import type { FC } from 'react';

interface SkeletonBlockProps {
  className?: string;
}

/** A pulsing placeholder block; the caller gives it its size. */
export const SkeletonBlock: FC<SkeletonBlockProps> = ({ className = '' }) => (
  <span className={`block animate-pulse bg-hairline ${className}`.trim()} />
);
